import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./index.css";

const AboutSection = () => {
  const controls1 = useAnimation();
  const controls2 = useAnimation();

  const { ref: ref1, inView: inView1 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-30% 0%", // Adding a margin of -100px to the top and bottom
  });

  // useInView hook for about-2 with margin
  const { ref: ref2, inView: inView2 } = useInView({
    threshold: 0.5, // Trigger when section 2 is 50% in view
    rootMargin: "-30% 0%", // Adding a margin of -100px to the top and bottom
  });

  // useEffect to control animations
  useEffect(() => {
    if (inView2) {
      controls1.start("hidden");
      controls2.start("visible");
    } else if (inView1) {
      controls1.start("visible");
      controls2.start("hidden");
    } else {
      controls1.start("hidden");
      controls2.start("hidden");
    }
  }, [controls1, controls2, inView1, inView2]);

  // Animation variants for about-1
  const about1Variants = {
    hidden: { opacity: 0.2 },
    visible: { opacity: 1 },
  };

  // Animation variants for about-2
  const about2Variants = {
    hidden: { opacity: 0.2 },
    visible: { opacity: 1 },
  };

  return (
    <section className="section-container">
      <h1 className="heading">
        {/* about-1 */}
        <motion.span className="about-1" ref={ref1} initial="hidden" animate={controls1} variants={about1Variants}>
          I am a passionate UI Engineer who bridges the gap between development and design.
        </motion.span>

        {/* about-2 */}
        <motion.span className="about-2" ref={ref2} initial="hidden" animate={controls2} variants={about2Variants}>
           I take responsibility to craft a good user experience using modern frontend architecture.
        </motion.span>
      </h1>
    </section>
  );
};

export default AboutSection;
